import { render, staticRenderFns } from "./AddBizPersonnel.vue?vue&type=template&id=4e768497&scoped=true&"
import script from "./AddBizPersonnel.vue?vue&type=script&lang=js&"
export * from "./AddBizPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e768497",
  null
  
)

export default component.exports